export class AccountPartiallyDeletedError extends Error {
  code?: string = 'account/partially-deleted';
}
